'use client'

import { Modal } from '@/components/ui/modal'
import { Button as ButtonMantine, Space, Title } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import Autoplay from 'embla-carousel-autoplay'
import useEmblaCarousel from 'embla-carousel-react'
import { useState } from 'react'

const MAX_CHARACTERS = 200

type Message = {
	name: string | null
	message: string
}

type MessagesProps = {
	messages: Message[]
}

export function Messages({ messages }: MessagesProps) {
	const [emblaRef] = useEmblaCarousel(
		{
			loop: true,
			align: 'center',
			slidesToScroll: 1,
		},
		[Autoplay({ delay: 3500, active: true })],
	)

	const [opened, { open, close }] = useDisclosure(false)
	const [selectedMessage, setSelectedMessage] = useState<Message | null>(null)

	const truncateText = (text: string, maxLength: number) => {
		if (text.length <= maxLength) {
			return text
		}
		return `${text.substring(0, maxLength)}...`
	}

	const handleViewMore = (message: Message) => {
		setSelectedMessage(message)
		open()
	}

	if (messages.length === 0) return null

	return (
		<div className="px-2 sm:px-4 md:px-8">
			<Space h={{ base: 25, sm: 35, lg: 50 }} />
			<Title>Mensagens de carinho</Title>
			<div className="relative w-full max-w-none mx-auto">
				<div className="overflow-hidden" ref={emblaRef}>
					<div className="flex w-[200px] h-[400px] md:w-full">
						{messages.map((message, i) => (
							<div className="px-1  md:px-2 flex-[0_0_100%] md:flex-[0_0_30%] xl:flex-[0_0_25%]" key={`message-${message.name}-${i}`}>
								<div
									className="text-black mt-5 text-sm sm:text-base w-full h-[300px]  p-3 md:p-4 mx-1 md:mx-2  border border-gray-100 rounded-lg shadow-md  duration-200 flex flex-col justify-between bg-white relative"
									style={{ zIndex: 1 }}
								>
									<div className="flex-1 flex items-center">
										<span className="leading-relaxed text-center md:text-left">{truncateText(message.message, MAX_CHARACTERS)}</span>
									</div>
									<div className="flex  items-center justify-between mt-2">
										<cite className="text-xs text-gray-600 not-italic">— {message.name || 'Anônimo'}</cite>
										{message.message.length > MAX_CHARACTERS && (
											<ButtonMantine size="sm" onClick={() => handleViewMore(message)}>
												Ver +
											</ButtonMantine>
										)}
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>

			<Modal opened={opened} onClose={() => close()} title={`Mensagem de ${selectedMessage?.name || 'Anônimo'}`}>
				{selectedMessage?.message}
			</Modal>
		</div>
	)
}
